var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"channel-icon",class:_vm.icon_class,attrs:{"title":_vm.channel_title}})
}
var staticRenderFns = []

export { render, staticRenderFns }